import { Globe } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

export const LanguageSelector = () => {
  const { language, changeLanguage, t } = useLanguage();

  return (
    <div className="fixed bottom-20 right-6 z-50" data-testid="language-selector">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            className="rounded-full glass shadow-lg gap-2"
          >
            <Globe className="w-4 h-4" />
            <span className="hidden sm:inline">{language === 'en' ? 'EN' : 'PT'}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[150px]">
          <DropdownMenuItem
            onClick={() => changeLanguage('en')}
            className={language === 'en' ? 'bg-accent' : ''}
            data-testid="lang-en"
          >
            🇬🇧 {t('english')}
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => changeLanguage('pt')}
            className={language === 'pt' ? 'bg-accent' : ''}
            data-testid="lang-pt"
          >
            🇵🇹 {t('portuguese')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
